import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SBAMultiSelectCheck,
  SBADropDown, SBAAutoComplete, SBAComboBox
} from "../../UiComponents/SBADropDown";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import { LicenseManager } from "ag-grid-enterprise";
import { DateRangePicker } from "rsuite";
import {
  getTaskTypesAction,
  getTasksAction,
  getTaskDetailsAction,
  getTaskAssigneeAction,
  getTaskDocumentsAction,
  getActivityTaskViewSelectAction,
  getAvailableTaskViewColumnsAction

} from "../../actions/tasksAction";
import {
  getCustomSettings,
  getTaskDetails,
  DownloadDocument,
  deleteTaskAPI,
  insertorupdateTask,
  insertOrUpdateActivityDocument,
  DeleteDocument, updateTaskComplete,
  getTaskViewColums, insertTaskViewsColumn, updateTaskViewName, deleteActivityTaskView,
  getTaskViewSettings, getAvailableTaskViewColumns, getActivityEntity
} from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { TasksEntityType } from "../../../config/investorConfig";
import { getActivityEntities } from "../../actions/investmentAction";
import { SBNotify } from "../../utils/sbNotify";
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { ToastContainer } from "react-toastify";
import { Modal } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import { Link } from "react-router-dom";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { exportToExcelUsingRef } from '../../utils/excelExporter';
import download from "../../../Images/download.svg"
import { TaskBoard,AttachmentModal} from "./taskBoard";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";

export const Tasks = () => {
  const removeDrawerTabIndex = () => {
    const drawers = document.getElementsByClassName('rs-drawer-wrapper');
    Array.from(drawers).forEach(drawer => {
      drawer.removeAttribute('tabIndex');
    });
  };
  removeDrawerTabIndex();


  const dispatch = useDispatch();
  const currentDate = new Date();

  const defStartDate = new Date(currentDate);
  defStartDate.setMonth(defStartDate.getMonth() - 3);

  const defEndDate = new Date(currentDate);
  defEndDate.setMonth(defEndDate.getMonth() + 3);

  const [startDate, setStartDate] = useState(defStartDate);
  const [endDate, setEndDate] = useState(defEndDate);
  const [formattedStartDate, setFormattedStartDate] = useState(()=>{
    return `${startDate.getFullYear()}-${(startDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${startDate.getDate().toString().padStart(2, "0")}`
  });
  const [formattedEndDate, setFormattedEndDate] = useState(()=> {
    return `${endDate.getFullYear()}-${(endDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${endDate.getDate().toString().padStart(2, "0")}`
  });

    const taskListFilters = JSON.parse(localStorage.getItem("TaskListFilters"));
    const LocalstartDate = taskListFilters?.startDate ? new Date(taskListFilters?.startDate) : formattedStartDate;
    const LocalendDate = taskListFilters?.endDate ? new Date(taskListFilters?.endDate) : formattedEndDate

  const taskGridRef = useRef();
  const availablecolumnRef = useRef();
  const selectedViewcolumnApi = useRef();
  const [colDef, setColDef] = useState([]);
  const [appliedFilter, setAppliedFilter] = useState({});
  const [selectedFromDate, setSelectedFromDate] = useState(defStartDate);
  const [selectedToDate, setSelectedToDate] = useState(defEndDate);

  useEffect(() => {
    const today = new Date();
    
    const fromDate = new Date();
    fromDate.setMonth(today.getMonth() - 3);  // 3 months back

    const toDate = new Date();
    toDate.setMonth(today.getMonth() + 3);  // 3 months ahead

    setSelectedFromDate(fromDate);
    setSelectedToDate(toDate);
}, []);
  const [customRange, setCustomRange] = useState(false);
  const [showDrawer, setshowDrawer] = useState(false);
  const [hideCompleted, sethideCompleted] = useState(false);
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  const isEditable = Gstate.authorizationData.isEditable;
  const taskType = Gstate?.tasks?.taskType || [];
  const taskLoading = Gstate?.tasks?.listLoading ;
  const Tasklist = Gstate?.tasks?.tasks?.map(task=>(
    {...task,
      StartDateTime:getFormattedDate(task.StartDateTime),
      ModifiedDate:getFormattedDate(task.ModifiedDate),
      CompletedDate:getFormattedDate(task.CompletedDate),
      DueDateTime:getFormattedDate(task.DueDateTime),
      TaskBody:removeHtmlTagsFormatter(task.TaskBody)
    })) || [];
  
  const taskView = Gstate?.tasks?.ActivityTaskView || [];
  const availableviewColumns = Gstate?.tasks?.AvailableTaskViewColumns || [];
  const availableviewColumnsloading = Gstate?.tasks?.isAvailableColumnsLoading;
  const [showDocument, setshowDocument] = useState(false);
  // const taskDetails=Gstate?.tasks?.taskDetails||[];
  const taskAssignees = Gstate?.tasks?.taskAssignee || [];
  const [selectedType, setSelectedType] = useState();
  const [selectedOwner, setSelectedOwner] = useState();
  const [selectedName, setSelectedName] = useState();
  const [selectedBody, setSelectedBody] = useState();
  const [selectedEntityType, setSelectedEntityType] = useState();
  const [selectedEntity, setSelectedEntity] = useState();
  const [selectedDueDate, setSelectedDueDate] = useState();
  const [selectedstartDate, setSelectedstartDate] = useState();
  const [selectedCompletedDate, setSelectedCompletedDate] = useState(false);
  const [selectedActivityId, setselectedActivityId] = useState();
  const [selectedActivityTaskId, setselectedActivityTaskId] = useState();
  const [taskDetails, setTaskDetail] = useState();
  const [tasks, setTasks] = useState(Tasklist);
  const [selectedtaskView, setSelectedtaskView] = useState({ "TaskViewId": -1, "TaskViewName": "Please Select" });
  const [Mode, setMode] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteProps, setDeleteProps] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedTaskDocuments, setSelectedTaskDocuments] = useState([]);
  const [deleteAttachModal, setDeleteAttachModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState();
  const TaskTypeid = taskType && taskType?.map((item) => item.TaskTypeId) || [];

  const [TaskTypeIds, setTaskTypeIds] = useState();
  const [saveTypeId, setsaveTypeId] = useState([]);
  const [newselectedFiles, setSelectedNewFiles] = useState([]);
  const activityEntities =useSelector((state) => state.ActivityEntity.Activityentity) || [];
  const [accountTaskEntities,setAccountTaskEntities]=useState([]);
  const [contactTaskEntities,setContactTaskEntities]=useState([]);
  const taskDocuments = Gstate?.tasks?.taskDocuments || [];



  //mode state
  const [viewMode, setViewMode] = useState('Grid');


  // Custom View
  const [showView, setshowView] = useState(false);
  const [selectedcustomtaskViewName, setSelectedcustomtaskViewName] = useState();
  const [selectedcustomtaskViewType, setSelectedcustomtaskViewType] = useState();
  const [selectedcustomStartdate, setSelectedcustomStartdate] = useState();
  const [selectedcustomEnddate, setSelectedcustomEnddate] = useState();
  const [customStartdate, setCustomStartdate] = useState([
    { value: -1, label: "Select" },
    { value: 1, label: "Last 1 Month" },
    { value: 2, label: "Last 3 Month" },
    { value: 3, label: "Last 6 Month" },
    { value: 4, label: "Last 1 Year" },
    { value: 5, label: "Last 1 Year 6 Month" },
    { value: 6, label: "Last 2 Years" },
    { value: 7, label: "Current Date" },
  ])
  const [customEnddate, setCustomEnddate] = useState([
    { value: -1, label: "Select" },
    { value: 1, label: "1 Month" },
    { value: 2, label: "3 Month" },
    { value: 3, label: "6 Month" },
    { value: 4, label: "1 Year" },
    { value: 5, label: "1 Year 6 Month" },
    { value: 6, label: "2 Years" },
  ])
  const [selectedviewColumns, setSelectedViewColumns] = useState([]);
  const [selectedcustomhidecompleted, setSelectedcustomhideCompleted] = useState();
  const [showRenameView, setshowRenameView] = useState(false);
  const [showdeleteviewModal, setShowdeleteviewModal] = useState(false);
  const [viewName, setViewName] = useState();
  const [titleName, setTitleName] = useState();
  const [availcolumns, setAvailColumns] = useState();

  const [parentRender, setParentRender] = useState(true);
  const [render, setRender] = useState(true);


  const [showAttachment, setShowAttachment] = useState(false);
  const [task, setTask] = useState(null);
  useEffect(()=>{
    getAccountContactEntities();
  },[]);
  const getEntityDataWithoutTerm = async (entityType,  activitySourceId) => {
    try {
        const response = await sbaAxios({
            url: `${getActivityEntity}ActivityEntityTypeIds=${entityType}&activitySourceId=${activitySourceId}`
        });
        return response;
    } catch (error) {
        console.error("Error fetching entity data:", error);
        throw error; 
    }
};
  useEffect(() => {
    document.title = "Tasks";
    dispatch(getTaskTypesAction());
    dispatch(getTasksAction(selectedFromDate, selectedToDate, TaskTypeid));
    dispatch(getTaskAssigneeAction());
    dispatch(getActivityTaskViewSelectAction());
    fetchGridData();
    dispatch(getActivityEntities(TasksEntityType.Contact, null, 2));
    setSelectedFiles([]);
    setSelectedNewFiles([]);
  }, [render]);

  useEffect(() => {
    setTasks(Tasklist);
    hidecompleteddata(hideCompleted);
    setSelectedTaskDocuments(taskDocuments);
    setSelectedViewColumns(availableviewColumns);
    if (Mode === "Edit") {
      //setSelectedCompletedDate(moment(taskDetails?.CompletedDate));
      setSelectedFiles(taskDocuments);
    }

  }, [Gstate]);
  const getAccountContactEntities=async()=>{
    try {
      const ContactList=await getEntityDataWithoutTerm(0,2);
      const accountList=await getEntityDataWithoutTerm(1,2);
      setAccountTaskEntities([...accountList]);
      setContactTaskEntities([...ContactList]);
    } catch (error) {
      
    }
  }
  const getCustomSetting = async (TaskViewId) => {
    try {
      if (TaskViewId !== -1) {
        const response = await sbaAxios({ url: `${getCustomSettings}${1015}` });
        if (response) {
          const apiColDef = JSON.parse(response.CustomSettingsValue);
          const apiFilters = JSON.parse(response.CustomFilterValue);
          const formattedDef = apiColDef.map((item) => {
            
            return {
              ...item,
              field: item.colId,
              cellRenderer:
                item.colId === "AttachmentCount"
                  ? HyperlinkRenderer
                  : item.colId === "Action"
                    ? EditButtonRenderer
                    : item.colId === "IsCompleted"
                      ? checkBoxRenderer
                      : null,
              // valueFormatter: item.colId === "TaskBody" ? removeHtmlTagsFormatter : null,
              // valueFormatter :item.colId === "CompletedDate" ? (data)=>{return data.value ? moment(data.value).format('MM/DD/YYYY') :""} : null,
              "headerName": item.colId === "TaskName" ? "Subject" : item.colId === "TaskType" ? "Type" : item.colId === "EntityTypeName" ? "Entity Type" : item.colId === "TaskBody" ? "Body" : item.colId === "AssignedToUserName" ? "Assigned To" : item.colId === "ModfiedByUserName" ? "Modified By" : item.colId === "StartDateTime" ? "Start Date" : item.colId === "DueDateTime" ? "Due Date" : item.colId === "IsCompleted" ? "Completed" : item.TaskViewColumn === "CompletedDate" ? 'Completed Date' : null,
            }
          });
          return { columns: formattedDef, filters: apiFilters };
        }
      }
      else {
        const response = await sbaAxios({ url: `${getAvailableTaskViewColumns}${0}`, });
        const filterResposne = await sbaAxios({ url: `${getCustomSettings}${1015}` });
        if (response && filterResposne ) {
          const apiFilters = JSON.parse(filterResposne.CustomFilterValue);
          const updatedcolumns = response.filter((item) => item.TaskColumnName !== "ModifiedDate")
          const formattedDef = updatedcolumns.map((item) => {
            return {
              ...item,
              field: item.TaskColumnName,
              // valueFormatter: item.TaskColumnName === "TaskBody" ? removeHtmlTagsFormatter : null,
              "headerName": item.TaskColumnName === "TaskName" ? "Subject" : item.TaskColumnName === "TaskType" ? "Type" : item.TaskColumnName === "EntityTypeName" ? "Entity Type" : item.TaskColumnName === "TaskBody" ? "Body" : item.TaskColumnName === "AssignedToUserName" ? "Assigned To" : item.TaskColumnName === "ModfiedByUserName" ? "Modified By" : item.TaskColumnName === "StartDateTime" ? "Start Date" : item.TaskColumnName === "DueDateTime" ? "Due Date" : item.TaskColumnName === "IsCompleted" ? "Completed" : item.TaskViewColumn === "CompletedDate" ? 'Completed Date' : null,
            }
          });
          formattedDef.push({ field: "Action", headerName: "Action", cellRenderer: EditButtonRenderer, filter: false });
          formattedDef.unshift({ field: "AttachmentCount", headerName: "Attachment Count", cellRenderer: HyperlinkRenderer });
          return { columns: formattedDef ,filters : apiFilters };

        }
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
  //Startdate calculation
  const getEndDate = (endDateOption) => {
    let endDate = new Date();

    if (endDateOption != null) {
      switch (endDateOption) {
        case 1:
          endDate.setMonth(endDate.getMonth() + 1);
          break;
        case 2:
          endDate.setMonth(endDate.getMonth() + 3);
          break;
        case 3:
          endDate.setMonth(endDate.getMonth() + 6);
          break;
        case 4:
          endDate.setFullYear(endDate.getFullYear() + 1);
          break;
        case 5:
          endDate.setMonth(endDate.getMonth() + 18);
          break;
        case 6:
          endDate.setFullYear(endDate.getFullYear() + 2);
          break;
        default:

          break;
      }
    } else {
      endDate.setFullYear(endDate.getFullYear() + 1);
    }

    return endDate;
  };
  //Enddate calculation

  const getStartDate = (startDateOption) => {
    let startDate = new Date();

    if (startDateOption != null) {
      switch (startDateOption) {
        case 1:
          startDate.setMonth(startDate.getMonth() - 1);
          break;
        case 2:
          startDate.setMonth(startDate.getMonth() - 3);
          break;
        case 3:
          startDate.setMonth(startDate.getMonth() - 6);
          break;
        case 4:
          startDate.setFullYear(startDate.getFullYear() - 1);
          break;
        case 5:
          startDate.setMonth(startDate.getMonth() - 18);
          break;
        case 6:
          startDate.setFullYear(startDate.getFullYear() - 2);
          break;
        default:

          break;
      }
    } else {
      startDate.setFullYear(startDate.getFullYear() - 1);
    }

    return startDate;
  };



  // Edit AttachementCount Link....
  const HyperlinkRenderer = (props) => {
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    useEffect(() => { setIsEdit(isEditable) }, [isEditable])
    const ActivityId = props.data.ActivityId;
    const handleLinkClick = (event) => {
      setShowAttachment(true);
      setTask(props.data);
      // setselectedActivityId(ActivityId);
      // setshowDocument(true);
      // dispatch(getTaskDocumentsAction(ActivityId));
    };

    return <Link onClick={isEdit && handleLinkClick}>{props.data.AttachmentCount !== 0 ? props.data.AttachmentCount : <i className="fa-solid fa-plus" />}</Link>;
  };

  const fetchGridData = async () => {
    try {
      const customSettings = await getCustomSetting(selectedtaskView.TaskViewId);
      setColDef(customSettings.columns);
      setAppliedFilter(customSettings.filters);
    } catch (error) {
      console.error("Error fetching custom settings:", error);
    }
  };
  // Get Task Details by ActivityId....
  const getTaskDetailsbyId = async (ActivityId) => {
    try {
      const response = await sbaAxios({
        url: `${getTaskDetails}${ActivityId}`,
        method: "get",
      });
      setSelectedBody(response?.TaskBody || "");
      setTaskDetail(response);
      dispatch(getActivityEntities(response.EntityTypeId, null, 2));
    } catch (error) {
      console.error("Error fetching entities from API:", error);
    }
  };
  // Task Type Change....
  const TaskTypeDDChange = (e) => {
    let value = e.value;
    setTaskTypeIds(value);
    const typeIds = e.value.map((tasks) => tasks.TaskTypeId);
    setsaveTypeId(typeIds);
    dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
  };
  // Custom View Change....
  const TaskViewddchange = async (e) => {
    console.log('view change: ', e.value)
    setSelectedtaskView(e.value);
    gettaskViewcolumns(e.value.TaskViewId)
    if (e.value.TaskViewId !== -1) {
      const customSettings = await gettaskViewcolumns(e.value.TaskViewId);
        setColDef(customSettings.columns);
        getTaskviewsettingsbyId(e.value.TaskViewId);
        
    }

    else {
        setTaskTypeIds([]);
        sethideCompleted(false);
        setSelectedFromDate(defStartDate);
        setSelectedToDate(defEndDate);
        dispatch(getTasksAction(defStartDate, defEndDate, TaskTypeid));
        const customSettings = await getCustomSetting(e.value.TaskViewId);
        setColDef(customSettings.columns);
    }
    sbaAxios({
      url: `${getAvailableTaskViewColumns}${0}`,
      method: 'get',
    })
      .then((res) => {

        setAvailColumns(res);
      })
      .catch((error) => {
        SBNotify({ Msg: error, type: "error" });
      });

   
  }


    const loadTransactionList = () => {
        const taskListFilters = {
            startDate: selectedFromDate.toISOString(),
            endDate: selectedToDate.toISOString()
        }
        localStorage.setItem('TaskListFilters', JSON.stringify(taskListFilters));
        setRender(value => !value);
    }



  const gettaskViewcolumns = async (viewId) => {

    const response = await sbaAxios({ url: `${getTaskViewColums}${viewId}` });
    if (response) {

      const formattedDef = response.map((item) => ({
        ...item  ,
        field: item.TaskViewColumn,
        // valueFormatter: item.TaskViewColumn === "TaskBody" ? removeHtmlTagsFormatter : item.TaskViewColumn === "DueDateTime" || item.TaskViewColumn === "ModifiedDate" || item.TaskViewColumn === "StartDateTime" ? getDateFormatted : item.TaskViewColumn === "CompletedDate" ? (data) => { return data.value ? moment(data.value).format('MM-DD-YYYY') : "" } : null,
        //  valueFormatter :item.TaskViewColumn === "CompletedDate" ? (data)=>{return data.value ? moment(data.value).format('MM/DD/YYYY') :""} : null,
        // cellRenderer: item.TaskViewColumn === "TaskBody" ? removeHtmlTagsFormatter : null,
        "headerName": item.TaskViewColumn === "TaskName" ? "Subject" : item.TaskViewColumn === "TaskType" ? "Type" : item.TaskViewColumn === "EntityTypeName" ? "Entity Type" : item.TaskViewColumn === "TaskBody" ? "Body" : item.TaskViewColumn === "AssignedToUserName" ? "Assigned To" : item.TaskViewColumn === "ModfiedByUserName" ? "Modified By" : item.TaskViewColumn === "StartDateTime" ? "Start Date" : item.TaskViewColumn === "DueDateTime" ? "Due Date" : item.TaskViewColumn === "IsCompleted" ? "Completed" : item.TaskViewColumn === "CompletedDate" ? 'Completed Date' : null,
      }));
      formattedDef.push({ field: "Action", headerName: "Action", cellRenderer: EditButtonRenderer, filter: false });
      formattedDef.unshift({ field: "AttachmentCount", headerName: "Attachment Count", cellRenderer: HyperlinkRenderer })
      return { columns: formattedDef };
    }
  }
  // Task Body Content Decode...
  const decodebody = (params) => {
    const body = params.value;
    const decodedbody = decodeURIComponent(body);
    return decodedbody;
  };
  // DateRange Onchange....
  const handleDateChange = (e) => {
    if (e) {
      setCustomRange(true);

      const newStartDate = e?.value?.start ?? selectedFromDate;  // Use new date or fallback to current
      const newEndDate = e?.value?.end ?? selectedToDate;

      setSelectedFromDate(newStartDate);
      setSelectedToDate(newEndDate);

      const typeIds = TaskTypeIds?.map((tasks) => tasks.TaskTypeId) || [];

      // Dispatch the action with the new date range and type IDs
      dispatch(getTasksAction(newStartDate, newEndDate, typeIds));
  }
  
  };
  // Grid date column formatted...

  //html data formatter
  // const removeHtmlTagsFormatter = (params) => {
  //   const { value } = params;
  //   if (typeof value !== 'string') {
  //     return value;
  //   }

  //   return value.replace(/<[^>]*>?/gm, '');
  // };



  // Task Details Delete....
  const deleteSelectedDetails = () => {
    sbaAxios({ url: `${deleteTaskAPI}${deleteProps.data.ActivityId}` })
      .then((res) => {
        setDeleteModal(false)
        const typeIds = TaskTypeIds === undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
        dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
        setParentRender(value => !value);
        SBNotify({
          Msg: "Selected Document Deleted Successfully",
          type: "success",
        });
        // setParentRender(value=>!value);
      })
      .catch((error) => {
        SBNotify({ Msg: error, type: "error" });
      });
  };
  //task board Action 
  const editTask = (props) => {
    const isComplete = props.data.IsCompleted;
    dispatch(getTaskDocumentsAction(props.data.ActivityId));
    setSelectedType({ "TaskTypeId": props.data.TaskTypeId, "TaskType": props.data.TaskType });
    // setSelectedBody(props.data.TaskBody);
    setSelectedName(props.data.TaskName);
    setSelectedDueDate(props.data.DueDateTime);
    setSelectedstartDate(props.data.StartDateTime);
    setselectedActivityId(props.data.ActivityId);
    setselectedActivityTaskId(props.data.ActivityTaskId);
    setSelectedOwner({ "AssignedToUserId": props.data.AssignedToUserId, "AssignedToUserName": props.data.AssignedToUserName });
    setSelectedEntity({ "EntityId": props.data.EntityId, "EntityName": props.data.EntityName.toLowerCase() });
    setSelectedEntityType(props.data.EntityTypeId === 1 ? TasksEntityType.Account : TasksEntityType.Contact);
    if (isComplete !== true) {
      getTaskDetailsbyId(props.data.ActivityId);
      setshowDrawer(true);
      setMode("Edit");
    }
    setSelectedNewFiles([]);
  }
  const deleteTask = (props) => {
    const isComplete = props.data.IsCompleted;
    if (isComplete !== true) {
      setDeleteProps(props);
      setDeleteModal(true);
    }
  }
  const boardAttachment = (props) => {
    const ActivityId = props.data.ActivityId;
    setselectedActivityId(ActivityId);
    setshowDocument(true);
    dispatch(getTaskDocumentsAction(ActivityId));
  }
  const markIsCompleted = (ActivityTaskID) => {
    const savecompletedata = {
      "ActivityTaskId": ActivityTaskID,
      "ModifiedByUserId": 0,
    }
    sbaAxios({
      url: `${updateTaskComplete}`,
      method: "post",
      data: savecompletedata,
    }).then((response) => {
      const typeIds = TaskTypeIds == undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
      dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
      setParentRender(value => !value);
    }).catch((error) => {
      console.error(error);
    });
  }
  // Task Grid Edit Button....
  const EditButtonRenderer = (props) => {
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    const [isEdit, setIsEdit] = useState(isEditable);
    useEffect(() => { setIsEdit(isEditable) }, [isEditable]);
    const handleEditClick = () => {
      const isComplete = props.data.IsCompleted;
      dispatch(getTaskDocumentsAction(props.data.ActivityId));
      setSelectedType({ "TaskTypeId": props.data.TaskTypeId, "TaskType": props.data.TaskType });
      // setSelectedBody(props.data.TaskBody);
      setSelectedName(props.data.TaskName);
      setSelectedDueDate(props.data.DueDateTime);
      setSelectedstartDate(props.data.StartDateTime);
      setselectedActivityId(props.data.ActivityId);
      setselectedActivityTaskId(props.data.ActivityTaskId);
      setSelectedOwner({ "AssignedToUserId": props.data.AssignedToUserId, "AssignedToUserName": props.data.AssignedToUserName });
      setSelectedEntity({ "EntityId": props.data.EntityId, "EntityName": props.data.EntityName });
      setSelectedEntityType(props.data.EntityTypeId === 1 ? TasksEntityType.Account : TasksEntityType.Contact);
      if (isComplete !== true) {
        getTaskDetailsbyId(props.data.ActivityId);
        setshowDrawer(true);
        setMode("Edit");
      }
      setSelectedNewFiles([]);


    }

    // Edit Attachment Grid  delete Button....
    const deleteSelectedDocument = () => {
      const isComplete = props.data.IsCompleted;
      if (isComplete !== true) {
        setDeleteProps(props);
        setDeleteModal(true);
      }
    };

    return (
      <>
        <button
          style={{ border: "none", height: "0px" }}
          onClick={(e) => { isEdit && handleEditClick() }}
        >
          <i
            className="fas fa-edit"
            style={{ color: (props.data.IsCompleted !== true && isEdit !== false) ? "#47A547" : "#808080", margin: "0 8px", cursor: "pointer" }}
          ></i>
        </button>
        <button
          style={{ border: "none", height: "0px" }}
          onClick={(e) => { isEdit && deleteSelectedDocument() }}
        >
          <i
            className="fas fa-trash"
            style={{ color: (props.data.IsCompleted !== true && isEdit !== false) ? "#DF001B" : "#808080", margin: "0 8px", cursor: "pointer" }}
          ></i>
        </button>
      </>
    );
  };

  // Task Grid Edit Button.....
  const checkBoxRenderer = (params) => {
    return <input type="checkbox" checked={params.value === true} disabled />;
  };

  // Close Drawer...
  const closeModal = () => {
    setshowDrawer(false);
  };

  // HideCompleted Checkbox change...
  const changehideCompleted = (e) => {
    sethideCompleted(e.target.checked);
    hidecompleteddata(e.target.checked);
  };

  // Hide completed tasks load..
  const hidecompleteddata = (IsHide) => {
    if (IsHide === true) {
      const filteredtasks = Tasklist.filter((item) => item.IsCompleted !== true);
      setTasks(filteredtasks);
    } else {
      setTasks(Tasklist);
    }
  }
  const changeCompleteddate = (e) => {
    setSelectedCompletedDate(e.target.checked);

  };

  const dynColumnDefs = [
    {
      field: "TaskName",
      headerName: "Name",
    },
    {
      field: "TaskBody",
      headerName: "Body",
      valueFormatter: removeHtmlTagsFormatter,
    },
    {
      field: "TaskType",
      headerName: "Type",
    },
    {
      field: "EntityTypeName",
      headerName: "Entity Type",
    },
    {
      field: "EntityName",
      headerName: "Entity Name",
    },
    {
      field: "AssignedToUserName",
      headerName: "Assigned To",
    },
    {
      field: "ModfiedByUserName",
      headerName: "Modified By",
    },
    {
      field: "ModifiedDate",
      headerName: "Last Modified",
      // valueFormatter: getDateFormatted,
    },

    {
      field: "DueDateTime",
      headerName: "Due Date",
      // valueFormatter: getDateFormatted,
    },
    {
      field: "StartDateTime",
      headerName: "Start Date",
      // valueFormatter: getDateFormatted,
    },
    {
      field: "IsCompleted",
      headerName: "Completed",
    },
    {
      field: "CompletedDate",
      headerName: "Completed Date",
      valueFormatter: getDateFormatted,
    },
    {
      field: "AttachmentCount",
      headerName: "No.of.Attachments",
    },
    {
      field: "",
      headerName: "Action",
      cellRenderer: EditButtonRenderer,
    },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    flex: 1,
    filter: "agTextColumnFilter",
    resizable:true
  };

  // Attachment Grid
  const defaultdocColDef = {
    sortable: true,
    flex: 1,
    resizable:true
  };
  // Drawer Start....
  const typedropdownchange = (e) => {
    setSelectedType(e.value);
  };

  const Ownerddchange = (e) => {
    setSelectedOwner(e.value);
  };


  const txtNamechange = (event) => {
    setSelectedName(event.target.value);
  };
  const duedateChange = (newDate) => {
    setSelectedDueDate(newDate);
  };

  const startdateChange = (newDate) => {
    setSelectedstartDate(newDate);
  };

  const completiondateChange = (newDate) => {
    setSelectedCompletedDate(newDate);
  };
  const txtBodyChange = (event) => {
    setSelectedBody(event.html);
  };
  const onAddButtonClick = () => {
    dispatch(getActivityEntities(TasksEntityType.Contact, null, 2));
    setshowDrawer(true);
    setMode("Add");
    setSelectedBody();
    setSelectedDueDate();
    setSelectedstartDate();
    setSelectedEntity({});
    setSelectedEntityType(TasksEntityType.Contact);
    setSelectedName();
    setSelectedOwner({
      "AssignedToUserId": -1,
      "AssignedToUserName": "Please Select",
    });
    setSelectedType({
      "TaskTypeId": -1,
      "TaskType": "Please Select",
    });
    setTaskDetail([]);
    setSelectedFiles([]);
  };

  const handleRadioChange = (event) => {
    const entityType = event.target.value === "account" ? TasksEntityType.Account : TasksEntityType.Contact;
    setSelectedEntityType(entityType);
    setSelectedEntity({EntityId:0,EntityName:''});
    dispatch(getActivityEntities(entityType, null, 2))
  };

  // Drawer end...

  // Edit Attachment start...
  const pdfview = (params) => {
    try {
      const documentId = params.data.DocumentId;
      const documentName = params.data.DocumentName;
      const fileExtension = params.data.DocumentExtension.toLowerCase();
        const urlBuild = DownloadDocument + btoa(documentId.toString());
        sbaAxios({ url: urlBuild }).then((response) => {
        if (fileExtension === "pdf") {
            window.open(urlBuild)
        } else {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(response);
          link.download = documentName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    } catch (error) {
      console.error("Error opening document:", error);
    }
  };


  const getFileIcon = (fileExtension) => {
    switch (fileExtension.toLowerCase()) {
      case "pdf":
        return <i class="far fa-file-pdf" style={{ color: "red" }}></i>;
      case "xlsx":
        return <i class="far fa-file-excel" style={{ color: "green" }}></i>;
      default:
        return <span>&#x1F4C4;</span>;
    }
  };

  const CustomCellRenderer = (params) => {
    const documentName = params.data.DocumentName;

    return <span onClick={() => pdfview(params)}>{documentName}</span>;
  };

  const iconRenderer = (params) => {
    const fileExtension = params.data.DocumentExtension;

    return <span>{getFileIcon(fileExtension)}</span>;
  };
  const AttachDeleteButtonRenderer = (props) => {

    const handleDeleteClick = () => {
      if (props.data.DocumentId !== 0) {
        setDeleteAttachModal(true);
        setSelectedDocumentId(props.data.DocumentId)
      }
      else {

        const updatedFiles = newselectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
        setSelectedNewFiles(updatedFiles);
        const seldoc = selectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
        setSelectedFiles(seldoc)
        document.getElementById('fileInput').style.display = 'none';
        document.getElementById('fileInput').value = '';
        document.getElementById('fileInput').style.display = 'block';

      }

    }

    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };
  const deleteSelectedAttachment = (DocId) => {
    sbaAxios({
      url: `${DeleteDocument}${selectedActivityId},${DocId}`
    })
      .then((res) => {
        setDeleteAttachModal(false);
        dispatch(getTaskDocumentsAction(selectedActivityId));
        const typeIds = TaskTypeIds == undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
        dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
        setParentRender(value => !value);
      })
      .catch((error) => {
        SBNotify({ Msg: error, type: "error" });
      });
  }

  const doccolumnDefs = [
    {
      field: "DocumentName",
      headerName: "File Name",
      cellRenderer: CustomCellRenderer,
    },
    {
      headerName: "",
      field: "DocumentName",
      maxWidth: 60,
      cellRenderer: iconRenderer,
    },
    {
      headerName: "Action",
      field: "DocumentId",
      maxWidth: 100,
      cellRenderer: AttachDeleteButtonRenderer,
    },
  ];
  const AttachmentFileChange = (event) => {
    const newFiles = event.target.files;
    if (newFiles.length > 0) {
      const updatedFiles = [];
      const startingRowIndex = updatedFiles.length;

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const fileName = file.name;

        const lastDotIndex = fileName.lastIndexOf('.');
        const name = lastDotIndex >= 0 ? fileName.substring(0, lastDotIndex) : fileName;
        const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';

        const reader = new FileReader();

        reader.onload = function () {
          if (reader.result) {
            const arrayBuffer = reader.result;
            const base64String = arrayBufferToBase64(arrayBuffer);
            const rowIndex = startingRowIndex + i;
            updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
            setSelectedTaskDocuments([...selectedTaskDocuments, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, rowIndex }]);
            const DocumentData = updatedFiles.map((obj) => ({
              ActivityId: selectedActivityId,
              DocumentId: 0,
              DocumentName: obj.fileName,
              DocumentContent: obj.base64String,
              DocumentExtension: obj.extension,
              DocumentDate: moment(startDate),
              RuleId: 0,
              IsPartnerLetter: false,
              IsEmailForwarded: false,
              IsReturnsProcessed: false,
              IsManagerLetter: false,
              ModifiedBy: 0,
              ActivitySourceId: 1
            }));

            sbaAxios({
              url: `${insertOrUpdateActivityDocument}`,
              method: "post",
              data: DocumentData,
            }).then((response) => {
              //   setshowDocument(false);
              dispatch(getTaskDocumentsAction(selectedActivityId));
              const typeIds = TaskTypeIds == undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
              dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
              setParentRender(value => !value);

            })
              .catch((error) => {
                console.error(error);
              });


          }
        };


        reader.readAsArrayBuffer(file);
      }
    }
  };
  const closedocumentmodal = () => {
    setshowDocument(false);
  };
  // Edit Attachment end...
  // insert CompletedDate
  const UpdateTasksComplete = () => {

    const savecompletedata = {
      "ActivityTaskId": selectedActivityTaskId,
      "ModifiedByUserId": 0,
    }
    sbaAxios({
      url: `${updateTaskComplete}`,
      method: "post",
      data: savecompletedata,
    }).then((response) => {
      setSelectedCompletedDate(false);
      const typeIds = TaskTypeIds == undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
      dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
    }).catch((error) => {
      console.error(error);
    });
  };
  // Insert/Update Tasks...
  const InsertorUpdateTasks = () => {

    let ifsave = true;
    const savedata = {
      "activityId": Mode === "Add" ? 0 : selectedActivityId,
      "activityTaskId": Mode === "Add" ? 0 : selectedActivityTaskId,
      "taskName": selectedName,
      "taskBody": selectedBody,
      "taskTypeId": selectedType.TaskTypeId,
      "entityTypeId": selectedEntityType,
      "entityId": selectedEntity.EntityId,
      "assignedToUserId": selectedOwner.AssignedToUserId,
      "startDateTime": selectedstartDate,
      "dueDateTime": selectedDueDate,
      "modifiedByUserId": 0,
      "taskStatus": "T",
    }

    if (selectedType.TaskTypeId === -1) {
      ifsave = false;
      SBNotify({ Msg: "Please Select the Activity Type", type: "error" });
    }
    else if (selectedOwner.AssignedToUserId === -1) {
      ifsave = false;
      SBNotify({ Msg: "Please Select the Owner", type: "error" });
    }
    else if (!selectedName) {
      ifsave = false;
      SBNotify({ Msg: "Please Enter Subject", type: "error" });
    }
    else if (!selectedstartDate) {
      ifsave = false;
      SBNotify({ Msg: "Please Enter the Start Date", type: "error" });
    }
    else if (!selectedDueDate) {
      ifsave = false;
      SBNotify({ Msg: "Please Enter the Due Date", type: "error" });
    }
    if (ifsave) {
      sbaAxios({
        url: `${insertorupdateTask}`,
        method: "post",
        data: savedata,
      }).then((response) => {
        if (newselectedFiles.length > 0) {

          InsertActivityDocuments(response);

        }

        if (Mode === "Edit") {
          if (selectedCompletedDate === true) {
            UpdateTasksComplete();
          }

        }
        closeModal();
        setshowDrawer(false);
        if (Mode === "Add")
          SBNotify({ Msg: "Task Saved Successfully", type: "success" });
        else
          SBNotify({ Msg: "Task Updated Successfully", type: "success" });
        const typeIds = TaskTypeIds == undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
        dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
        setRender(value => !value);
      }).catch((error) => {
        SBNotify({ Msg: "some error  occured", type: "error" });
      });
    }

  };
  // Insert Documents...
  const InsertActivityDocuments = (activityid) => {
    const DocumentData = newselectedFiles.map((obj) => ({
      ActivityId: activityid,
      DocumentId: 0,
      DocumentName: obj.DocumentName,
      DocumentContent: obj.base64String,
      DocumentExtension: obj.DocumentExtension,
      DocumentDate: moment(startDate),
      RuleId: 0,
      IsPartnerLetter: false,
      IsEmailForwarded: false,
      IsReturnsProcessed: false,
      IsManagerLetter: false,
      ModifiedBy: 0,
      ActivitySourceId: 1
    }));

    sbaAxios({
      url: `${insertOrUpdateActivityDocument}`,
      method: "post",
      data: DocumentData,
    }).then((response) => {
      const typeIds = TaskTypeIds == undefined ? "" : TaskTypeIds?.map((tasks) => tasks.TaskTypeId);
      dispatch(getTasksAction(selectedFromDate, selectedToDate, typeIds));
      setParentRender(value => !value);

    })

      .catch((error) => {
        console.error(error);
      });

  };
  // Add Attachment Start....
  const DeleteButtonRenderer = (props) => {
    const handleDeleteClick = () => {
      const updatedFiles = selectedFiles.filter((item, index) => item.rowIndex !== props.data.rowIndex);
      setSelectedFiles(updatedFiles);
      document.getElementById('fileInput').style.display = 'none';
      document.getElementById('fileInput').value = '';
      document.getElementById('fileInput').style.display = 'block';
    }
    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };
  const AttachmentCellRenderer = (params) => {
    const documentName = params.data.DocumentName;
    return <span onClick={() => pdfview(params)}>{documentName}</span>;
  };
  const columnnewdocDefs = [
    {

      field: "DocumentName",
      headerName: "File Name",
      sort: "asc",
      pinned: "left",
      width: 400,
      filter: "agTextColumnFilter",
      cellRenderer: AttachmentCellRenderer,
      tooltipField: 'FileName'
    },
    {
      field: "DocumentExtension",
      headerName: "Extension",
      pinned: "left",
      maxWidth: 150,
    },
    {
      headerName: "Delete",
      field: "",
      maxWidth: 100,
      cellRenderer: AttachDeleteButtonRenderer
    }
  ];
  const Attachopen = (params) => {
    const selectedFile = params.data;
    if (selectedFile) {
      const dataUrl = `data:application/pdf;base64,${selectedFile.base64String}`;
      const newWindow = window.open('', '_blank');
      newWindow.document.write("<iframe width='100%' height='100%' src='" + dataUrl + "'></iframe>");
    }
  };
  const handleFileChange = (event) => {
    const newFiles = event.target.files;

    if (newFiles.length > 0) {
      const updatedFiles = [...newselectedFiles];
      const startingRowIndex = updatedFiles.length;

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        const fileName = file.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
        const reader = new FileReader();
        reader.onload = function () {
          if (reader.result) {
            const arrayBuffer = reader.result;
            const base64String = arrayBufferToBase64(arrayBuffer);
            const rowIndex = startingRowIndex + i;
            updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
            //    setSelectedTaskDocuments([...selectedTaskDocuments, { DocumentId: 0, DocumentName: fileName,DocumentExtension:extension,rowIndex}]);
            setSelectedNewFiles([...newselectedFiles, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, base64String: base64String, rowIndex }]);
            setSelectedFiles([...selectedFiles, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, rowIndex }]);

          }
        };

        reader.readAsArrayBuffer(file);
      }
    }

  };
  // Attachment Add end...
  const arrayBufferToBase64 = (arrayBuffer) => {
    const binary = [];
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary.push(String.fromCharCode(bytes[i]));
    }
    return btoa(binary.join(''));
  };
  // Task View Column
  const OpenCustomWindow = () => {

    if (selectedtaskView.TaskViewId === -1) {

      SBNotify({ Msg: "Please select Custom view", type: "error" });
    }
    else {
      setshowView(true);
      getTaskviewsettingsbyId(selectedtaskView.TaskViewId);
      dispatch(getAvailableTaskViewColumnsAction(selectedtaskView.TaskViewId))
    }
  };
  const getTaskviewsettingsbyId = (viewId) => {
    sbaAxios({
      url: `${getTaskViewSettings}${viewId},${true}`
    })
      .then((res) => {
        setSelectedcustomtaskViewName({ "TaskViewId": res[0].TaskViewId, "TaskViewName": res[0].TaskViewName });
        let activityTypeId = "";
        res.forEach(item => {
          if (item.SettingName === "ActivityType")
            activityTypeId = activityTypeId === "" ? item.SettingValue.toString() : activityTypeId + "," + item.SettingValue.toString();
        });
        const activityTypeIds = activityTypeId.split(',').map(id => parseInt(id.trim(), 10));
        const data = taskType.filter(item => activityTypeIds.includes(item.TaskTypeId));
        setSelectedcustomtaskViewType(data);
        setTaskTypeIds(data);
        dispatch(getTasksAction(selectedFromDate, selectedToDate, activityTypeId));
        setSelectedtaskView({ "TaskViewId": res[0].TaskViewId, "TaskViewName": res[0].TaskViewName });
        let ishidecompleted = 0;
        let startdateoption = 0;
        let endDateoption = 0;
        res.forEach(item => {
          if (item.SettingName === "TaskCompleted")
            ishidecompleted = item.SettingValue;
          else if (item.SettingName === "StartDateOption")
            startdateoption = item.SettingValue;
          else if (item.SettingName === "DateOption")
            endDateoption = item.SettingValue;
        });
        const startdate = customStartdate.find(item => item.value === startdateoption);
        const enddate = customEnddate.find(item => item.value === endDateoption);
        setSelectedFromDate(()=>{
          const newStartDate = new Date();
              switch (startdate.value) {
                case 1:
                  newStartDate.setMonth(newStartDate.getMonth() - 1);
                  break;
                case 2:
                  newStartDate.setMonth(newStartDate.getMonth() - 3);
                  break;
                case 3:
                  newStartDate.setMonth(newStartDate.getMonth() - 6);
                  break;
                case 4:
                  newStartDate.setFullYear(newStartDate.getFullYear() - 1);
                  break;
                case 5:
                  newStartDate.setFullYear(newStartDate.getFullYear() - 1);
                  newStartDate.setMonth(newStartDate.getMonth() - 6);
                  break;
                case 6:
                  newStartDate.setFullYear(newStartDate.getFullYear() - 2);
                  break;
                case 7:
                  newStartDate.setTime(currentDate.getTime());
                  break;
                default:
                  newStartDate.setMonth(newStartDate.getMonth() - 3);
              }
          return newStartDate
        });
        setSelectedToDate(()=>{
          const newEndDate = new Date();
          switch (enddate.value) {
            case 1:
              newEndDate.setMonth(newEndDate.getMonth() + 1);
              break;
            case 2:
              newEndDate.setMonth(newEndDate.getMonth() + 3);
              break;
            case 3:
              newEndDate.setMonth(newEndDate.getMonth() + 6);
              break;
            case 4:
              newEndDate.setFullYear(newEndDate.getFullYear() + 1);
              break;
            case 5:
              newEndDate.setFullYear(newEndDate.getFullYear() + 1);
              newEndDate.setMonth(newEndDate.getMonth() + 6);
              break;
            case 6:
              newEndDate.setFullYear(newEndDate.getFullYear() + 2);
              break;
            default:
              newEndDate.setMonth(newEndDate.getMonth() + 3);
          }
          return newEndDate;
        });
        setSelectedcustomStartdate(startdate ? startdate : { value: "4", label: "Last 1 Year" });
        setSelectedcustomEnddate(enddate ? enddate : { value: "4", label: "Last 1 Year" });
        setSelectedcustomhideCompleted(ishidecompleted === 0 ? false : true);
        sethideCompleted(ishidecompleted === 0 ? false : true);
      })
      .catch((error) => {
        SBNotify({ Msg: error, type: "error" });
      });
  };
  const customtaskviewnameonchange = (e) => {
    setSelectedcustomtaskViewName(e.value);
    getTaskviewsettingsbyId(e.value.TaskViewId);
  };
  const customtasktypenameonchange = (e) => {
    setSelectedcustomtaskViewType(e.value);
  };
  const CustomStartDateChange = (e) => {
    setSelectedcustomStartdate(e.value);
    const newStartDate = new Date();
  switch (e.value.value) {
    case 1:
      newStartDate.setMonth(newStartDate.getMonth() - 1);
      break;
    case 2:
      newStartDate.setMonth(newStartDate.getMonth() - 3);
      break;
    case 3:
      newStartDate.setMonth(newStartDate.getMonth() - 6);
      break;
    case 4:
      newStartDate.setFullYear(newStartDate.getFullYear() - 1);
      break;
    case 5:
      newStartDate.setFullYear(newStartDate.getFullYear() - 1);
      newStartDate.setMonth(newStartDate.getMonth() - 6);
      break;
    case 6:
      newStartDate.setFullYear(newStartDate.getFullYear() - 2);
      break;
    case 7:
      newStartDate.setTime(currentDate.getTime());
      break;
    default:
      return;
  }

  setSelectedFromDate(newStartDate);
  };
  const CustomEndDateChange = (e) => {
    setSelectedcustomEnddate(e.value);

    const newEndDate = new Date();
  switch (e.value.value) {
    case 1:
      newEndDate.setMonth(newEndDate.getMonth() + 1);
      break;
    case 2:
      newEndDate.setMonth(newEndDate.getMonth() + 3);
      break;
    case 3:
      newEndDate.setMonth(newEndDate.getMonth() + 6);
      break;
    case 4:
      newEndDate.setFullYear(newEndDate.getFullYear() + 1);
      break;
    case 5:
      newEndDate.setFullYear(newEndDate.getFullYear() + 1);
      newEndDate.setMonth(newEndDate.getMonth() + 6);
      break;
    case 6:
      newEndDate.setFullYear(newEndDate.getFullYear() + 2);
      break;
    default:
      return;
  }

  setSelectedToDate(newEndDate);
  };
  const changecustomhidecompleted = (e) => {
    setSelectedcustomhideCompleted(e.target.checked);

  };
  const txtChangeNewName = (e) => {
    setViewName(e.target.value);
  };
  var AvailablecolumnDefs = [
    {
      field: "TaskColumnName",
      headerName: "TaskViewColumn",
    },
  ];
  const selectedcolumnDefs = [
    {
      rowDrag: true,
      field: "TaskColumnName",
      headerName: "TaskViewColumn",
    },
  ];
  const addViewColumns = (e) => {
    const availablecolumns = availablecolumnRef.current.api.getSelectedRows()[0];
    availablecolumns && addSelectedViewColumns(availablecolumns);

  };
  const addSelectedViewColumns = (availablecolumns) => {
    let isadd = true;
    selectedviewColumns.map((item) => {

      if (item.TaskColumnName === availablecolumns.TaskColumnName) {
        SBNotify({ Msg: "Column Name already exsits ", type: "error" });
        isadd = false;
      }
    })
    if (isadd === true) {
      const toAdd = {
        "rowIndex": selectedviewColumns.length,
        "TaskViewId": availablecolumns.TaskViewId,
        "TaskViewName": availablecolumns.TaskViewName,
        "TaskColumnName": availablecolumns.TaskColumnName,
        "TaskColumnId": availablecolumns.TaskColumnId,

      };

      setSelectedViewColumns((pv) => {
        return [...pv, { ...toAdd }]
      });
    }

  };
  const removeViewColumns = () => {
    const viewIndex = selectedViewcolumnApi.current.api.getSelectedRows()[0];
    viewIndex && removeSelectedViewColumns(viewIndex);
  };
  const removeSelectedViewColumns = (viewindex) => {
    setSelectedViewColumns(pv => ((pv.filter(item => item.TaskColumnName !== viewindex.TaskColumnName).map((item, index) => { return { ...item, rowIndex: index } }))));
  };
  // insert Column view 
  const InsertTaskViewsColumn = async (mode) => {

    try {
      const columnIds = selectedviewColumns.map(item => item.TaskColumnId);
      const activityIds = selectedcustomtaskViewType.map(item => item.TaskTypeId);
      const taskViewsColumn = {
        "TaskViewId": mode === "Edit" ? selectedcustomtaskViewName.TaskViewId : 0,
        "TaskViewName": mode === "Edit" ? selectedcustomtaskViewName.TaskViewName : viewName,
        "TaskStartDateOption": selectedcustomStartdate.value,
        "TaskEndDateOption": selectedcustomEnddate.value,
        "IsTaskCompleted": selectedcustomhidecompleted,
        "TaskActivityTypeIds": activityIds.join(','),
        "TaskColumnIds": columnIds.join(','),
        "UserId": 0,
      };

      if (mode === "New" && !viewName) {
        SBNotify({ Msg: "Please enter a view name.", type: "error" });
      }
      else if (columnIds.length === 0) {
        SBNotify({ Msg: "Please select Minimum 1 View Column to Save", type: "error" });
      }
      else if (activityIds.length === 0) {
        SBNotify({ Msg: "Please select Minimum 1 Task Type to Save", type: "error" });
      }

      else {
        const response = await sbaAxios({
          url: insertTaskViewsColumn,
          method: 'post',
          data: taskViewsColumn,
        });

        if (response === -1) {
          SBNotify({ Msg: "View name already exists.", type: "error" });
        }

        else {
          dispatch(getActivityTaskViewSelectAction());
          getTaskviewsettingsbyId(response);
          dispatch(getAvailableTaskViewColumnsAction(response));
          dispatch(getTasksAction(selectedFromDate, selectedToDate, activityIds));
          sethideCompleted(selectedcustomhidecompleted);
          const start = getStartDate(selectedcustomStartdate.value);
          const end = getEndDate(selectedcustomEnddate.value);
          setSelectedFromDate(start);
          setSelectedToDate(end);
          const customSettings = await gettaskViewcolumns(response);
          setColDef(customSettings.columns);

          const successMessage = mode === "Edit" ? "Task View updated successfully." : "Task View inserted successfully.";
          SBNotify({
            Msg: successMessage,
            type: "success",
          });
          setshowRenameView(false);
        }
      }
    }
    catch (error) {
      console.error("Error inserting/updating task view columns:", error.message);
      SBNotify({
        Msg: error.message,
        type: "error",
      });

    }
  };
  // Update Column view 
  const UpdateTaskViewsColumn = async () => {

    try {
      const updateViewsColumn = {
        "TaskViewId": selectedcustomtaskViewName.TaskViewId,
        "TaskViewName": viewName,
        "UserId": 0,
      };
      if (!viewName) {
        SBNotify({ Msg: "Please enter a view name.", type: "error" });
      }
      else {
        const response = await sbaAxios({
          url: updateTaskViewName,
          method: 'post',
          data: updateViewsColumn,
        });


        if (response === -1) {
          SBNotify({ Msg: "View Name Name already exsits ", type: "error" });
        }
        else if (response > 0) {
          SBNotify({
            Msg: "Task View Update Successfully",
            type: "success",
          });
          setshowRenameView(false);
          dispatch(getActivityTaskViewSelectAction());
          getTaskviewsettingsbyId(response);
          dispatch(getAvailableTaskViewColumnsAction(response));
          dispatch(getTasksAction(selectedFromDate, selectedToDate, TaskTypeIds));
          const customSettings = await gettaskViewcolumns(response);
          setColDef(customSettings.columns);
        }


      }
    }
    catch (error) {
      console.error("Error inserting/updating task view columns:", error.message);
      SBNotify({
        Msg: error.message,
        type: "error",
      });

    }
  };
  // Delete task column view
  const deleteTaskview = async () => {
    let UserId = 0;
    let TaskViewId = selectedcustomtaskViewName.TaskViewId;
    try {
      const response = await sbaAxios({
        url: `${deleteActivityTaskView}${TaskViewId},${UserId}`,
        method: 'get',

      });
      setShowdeleteviewModal(false);
      setshowView(false);
      dispatch(getActivityTaskViewSelectAction());
      setSelectedtaskView({ "TaskViewId": -1, "TaskViewName": "Please Select" });
      setTaskTypeIds([]);
      const customSettings = await getCustomSetting(-1);
      setColDef(customSettings.columns);
      dispatch(getTasksAction(selectedFromDate, selectedToDate, ""));
    }
    catch (error) {
      console.error("Error Deleting task view columns:", error.message);
      SBNotify({
        Msg: error.message,
        type: "error",
      });

    }

  };
  const entityChange = (e) => {


    // if (e.syntheticEvent.type === "change") {
    //   if (e.value) {

    //     dispatch(getActivityEntities(selectedEntityType, e.value, 2))

    //   }
    // }
    if (e.syntheticEvent.type === "click") {
      const selectedDataItem = activityEntities.find(item => item.EntityName === e.target.value);
      setSelectedEntity(selectedDataItem);
    }

  };
  const RenameEditbutton = () => {
    setshowRenameView(true);
    setTitleName("Rename View");
    setViewName(selectedcustomtaskViewName.TaskViewName);
  };
  const InsertNewview = () => {
    setshowRenameView(true);
    setTitleName("New View");
    setViewName(selectedcustomtaskViewName.TaskViewName);
  };
  const updateSortOrder = (e) => {
    const { api } = e;
    const sortedData = [];
    api.forEachNodeAfterFilterAndSort((node) => {
      sortedData.push(node.data);
    });
    setSelectedViewColumns(sortedData);
  };


    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` },{ BreadCrumb: "Tasks", Routes: `${UrlPath.Transactions}` }];
  return (
    <>
      <TopBar label={"Tasks"} />
      <div id="TaskList" className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="d-inline-flex mb-2">
            <button
              className={`toggle-btn rounded-start ${viewMode === 'Grid' ? 'active' : 'inActive'}`}
              onClick={() => { setViewMode('Grid'); setRender(value=>!value);}}
            >
              <span>
                <img
                  src='/images/gridIcon.svg'
                  alt=""
                  style={{
                    filter: `${viewMode === 'Grid' ? 'brightness(100%)' : 'brightness(50%)'}`,
                  }}
                />
                <span className="mx-1"></span>
                Grid View
              </span>
            </button>
            <button
              className={`toggle-btn rounded-end ${viewMode === 'Board' ? 'active' : 'inActive'}`}
              onClick={() => { setViewMode('Board') }}
            >
              <span>
                <img
                  src='/images/boardIcon.svg'
                  alt=""
                  style={{
                    filter: `${viewMode === 'Board' ? 'brightness(100%)' : 'brightness(50%)'}`,
                  }}
                />
                <span className="mx-1"></span>
                Board View
              </span>

            </button>
          </div>
          {viewMode === 'Grid' && <> <div className="row">
            <div className="col-md-2">
              <label className="mb-1 label">Select Date Range</label>
              <SBDateRangePicker  value={{start:new Date(selectedFromDate), end:new Date(selectedToDate)}}    onChange={handleDateChange}/>
                {/* <DateRangePicker
                  className="SbaDateRage text-dark"
                  placeholder="Select Date Range"
                  value={[
                    selectedFromDate
                      ? moment(selectedFromDate).toDate()
                      : new Date(),
                    selectedToDate
                      ? moment(selectedToDate).toDate()
                      : new Date(),
                  ]}
                  format="MM/dd/yyyy"
                  block
                  character=" - "
                  onChange={handleDateChange}
                /> */}
              
            </div>
            <div className="col-md-3">
              <label htmlFor="select fund" className="mb-1 label">
                Task Type
              </label>
              <div>
                <SBAMultiSelectCheck
                  className="w-100"
                  data={taskType}
                  value={TaskTypeIds}
                  dataItemKey="TaskTypeId"
                  textField="TaskType"
                  onChange={TaskTypeDDChange}
                  tags={
                    TaskTypeIds?.length > 0
                      ? [
                        {
                          text: `${TaskTypeIds?.length} items selected`,
                          data: [...TaskTypeIds],
                        },
                      ]
                      : []
                  }
                />
              </div>
            </div>
            <div className="col-md-3 p-4">
              <div className="p-2">
                <input
                  className="p-4"
                  type="checkbox"
                  checked={hideCompleted}
                  onChange={changehideCompleted}
                />
                <label className="label ms-2">Hide Completed</label>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-end">
              <div className="w-100">
                <label className="mb-1 label">Custom View</label>
                <div className="d-flex gap-2">
                  <SBADropDown
                    className="w-100"
                    textField={"TaskViewName"}
                    valueField={"TaskViewId"}
                    data={taskView}
                    value={selectedtaskView}
                    onChange={TaskViewddchange}
                  />
                  <button
                    type="submit"
                    className="p-sm-btn mx-1"
                    disabled={!isEditable}
                    onClick={() => onAddButtonClick()}
                  >
                    <i className="fa-solid fa-plus" /> Add
                  </button>
                  <button
                    type="button"
                    className="p-sm-btn mx-1"
                    onClick={() => {
                      exportToExcelUsingRef(
                        taskGridRef,
                        "Tasks.xlsx"
                      );
                    }}
                  >
                    <img src={download} alt="" /> Export
                  </button>
                  <i className="fa-solid fa-gear  p-2" onClick={() => OpenCustomWindow()}></i>



                </div>
              </div>
            </div>
          </div>

            <TaskGrid taskLoading={taskLoading} taskGridRef={taskGridRef} colDef={colDef} appliedFilter={appliedFilter} tasks={tasks} /> </>}
          {viewMode === 'Board' && <> <TaskBoard /> </>}
          <div>
          </div>
        </div>
      </div>
      <SBADrawer
        open={showDrawer}
        setOpen={setshowDrawer}
        close={false}
        title={"Insert/Update Task"}
      >
        <div>
          <div>
            <div className="mb-4">
              <label className="header-container m-1">
                <b>Activity Type:</b>
              </label>

              <div>
                <SBADropDown
                  className="w-50"
                  textField={"TaskType"}
                  valueField={"TaskTypeId"}
                  data={taskType}
                  value={selectedType}
                  popupSettings={{ className: "modalDD" }}
                  disabled={Mode === "Edit"}
                  onChange={typedropdownchange}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="header-container m-1">
                <b>Owner:</b>
              </label>
              <div>
                <SBADropDown
                  className="w-50"
                  textField={"AssignedToUserName"}
                  valueField={"AssignedToUserId"}
                  data={taskAssignees}
                  value={selectedOwner}
                  popupSettings={{ className: "modalDD" }}
                  onChange={Ownerddchange}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="header-container m-1">
                <b>Subject: </b>
              </label>
              <div>
                <input
                  className="form-control w-50"
                  type="text"
                  value={selectedName}
                  onChange={txtNamechange}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="header-container m-1">
                <b>Start Date: </b>
              </label>
              <div>
                <SBDatePicker
                  className="w-50"
                  id="DueDate"
                  value={selectedstartDate ? moment(selectedstartDate) : null}
                  onChange={startdateChange}
                ></SBDatePicker>
              </div>
            </div>

            <div className="mb-4">
              <label className="header-container m-1">
                <b>Due Date: </b>
              </label>
              <div>
                <SBDatePicker
                  className="w-50"
                  id="DueDate"
                  value={selectedDueDate ? moment(selectedDueDate) : null}
                  onChange={duedateChange}
                ></SBDatePicker>
              </div>
            </div>
            {Mode === "Edit" ? (
              //<div className="mb-4">
              //  <label className="header-container m-1">
              //    <b>Completion Date:</b>
              //  </label>
              //  <div>
              //    <SBDatePicker
              //      className="w-50"
              //      id="completedDate"
              //      value={selectedCompletedDate}
              //      onChange={completiondateChange}
              //    />
              //  </div>
              //</div>
              <div className="p-2">
                <input
                  className="p-4"
                  type="checkbox"
                  id="completedDate"
                  checked={selectedCompletedDate}
                  onChange={changeCompleteddate}
                />
                <label className="label ms-2">Is Completed</label>
              </div>
            ) : (
              ""
            )}
            <div className="mb-4">
              <label className="header-container m-1">
                <b>Body:</b>
              </label>
              <div>

                <SBAEditor id="editor" onChange={txtBodyChange} defaultContent={selectedBody} editorHeight={300} setContent={setSelectedBody} />

              </div>
            </div>
            <div className="mb-4">
              <div className="d-flex align-items-center gap-5">
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="table-options"
                    id="contact"
                    value="contact"
                    checked={selectedEntityType === 0}
                    // disabled={Mode === "Edit"}
                    onChange={handleRadioChange}
                  />
                  <label htmlFor="asset" className="form-check-label">
                    Contacts
                  </label>
                </div>
                <div className="form-check ms-3">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="table-options"
                    id="account"
                    value="account"
                    checked={selectedEntityType === 1}
                    // disabled={Mode === "Edit"}
                    onChange={handleRadioChange}
                  />
                  <label htmlFor="group" className="form-check-label">
                    Accounts
                  </label>
                </div>
                {(selectedEntityType === 0) && <> <SBAComboBox
                    data={contactTaskEntities}
                    onChange={(e) => { setSelectedEntity(e.value) }}
                    textField="EntityName"
                    popupSettings={{className: 'modalDD' }}
                    valueField={"EntityId"}
                    value={{ EntityId: selectedEntity?.EntityId, EntityName: [...accountTaskEntities,...contactTaskEntities].find(item=>item.EntityId==selectedEntity?.EntityId)?.EntityName }}
                /></>}
                {selectedEntityType === 1 && <>  <SBAComboBox
                    data={accountTaskEntities} 
                    onChange={(e) => { setSelectedEntity(e.value) }}
                    textField="EntityName"
                    popupSettings={{ className: 'modalDD' }}
                    valueField={"EntityId"}
                    value={{ EntityId: selectedEntity?.EntityId, EntityName: [...accountTaskEntities,...contactTaskEntities].find(item=>item.EntityId==selectedEntity?.EntityId)?.EntityName }}

                /></>}

              </div>
            </div>
            {/*{Mode === "Add" && (*/}
            <>
              <div className="row" style={{ marginTop: "10px" }}>
                <div style={{ position: "relative" }}>
                  <input
                    type="file"
                    id="fileInput"
                    className="input-hidden"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="row" style={{ marginTop: "10px" }}>
                <div
                  className="ag-theme-alpine"
                  style={{ width: "100%", height: "300px" }}
                >
                  <AgGridReact
                    columnDefs={columnnewdocDefs}
                    rowData={selectedFiles}
                    defaultColDef={defaultdocColDef}
                    overlayNoRowsTemplate={`<span>${"No data Available"}</span>`}
                  ></AgGridReact>
                </div>
              </div>
            </>
            {/* )}*/}
            <div className="mt-4">
              <button className="s-sm-btn mx-1" onClick={closeModal}>
                Cancel
              </button>
              <button className="p-sm-btn mx-1" onClick={InsertorUpdateTasks}>
                Save
              </button>
            </div>
          </div>
        </div>
      </SBADrawer>
      {/* Task Delete Modal ----- */}
      <div class=".model-xl ">
        <Modal show={showDocument}>
          <Modal.Header closeButton onClick={closedocumentmodal}>
            <Modal.Title>Attachment Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ag-theme-alpine" style={{ width: "100%" }}>
              {selectedTaskDocuments.length === 0 ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                  No records found</div>
              ) : (
                <AgGridReact
                  columnDefs={doccolumnDefs}
                  rowData={selectedTaskDocuments}
                  defaultColDef={defaultdocColDef}
                ></AgGridReact>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className="row" style={{ marginTop: "10px" }}>
              <div style={{ position: "relative" }}>
                <input
                  type="file"
                  id="fileInput"
                  className="input-hidden"
                  onChange={AttachmentFileChange}
                />
              </div>
            </div>
            <button className="s-sm-btn mx-1" onClick={closedocumentmodal}>
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
      <Modal show={deleteModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setDeleteModal(false);
          }}
        >
          <Modal.Title>Do you want to delete the selected Task?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Task will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setDeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={() => {
              deleteSelectedDetails();
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>

      {/* Attachment Delete Modal ----- */}
      <Modal show={deleteAttachModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setDeleteAttachModal(false);
          }}
        >
          <Modal.Title>
            Do you want to delete the selected Document?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Document will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setDeleteAttachModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={() => {
              deleteSelectedAttachment(selectedDocumentId);
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>


      {/* View Settings Column ----- */}
      <SBADrawer
        open={showView}
        setOpen={setshowView}
        close={false}
        title={"Custom View"}
      >
        <div className="drawer">
          <div>
            <div className="mb-4">
              <label className="header-container m-1">
                <b>View Name:</b>
              </label>

              <div>
                <SBADropDown
                  className="w-50"
                  textField={"TaskViewName"}
                  valueField={"TaskViewId"}
                  data={taskView}
                  value={selectedcustomtaskViewName}
                  popupSettings={{ className: "modalDD" }}
                  onChange={customtaskviewnameonchange}
                />
                <i
                  className="fas fa-pencil" onClick={RenameEditbutton}
                  style={{ margin: "0 8px", cursor: "pointer" }}
                ></i>
                <i
                  className="fas fa-trash" onClick={() => { setShowdeleteviewModal(true) }}
                  style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                ></i>
              </div>

            </div>

            <div className="mb-4">
              <label className="header-container m-1">
                <b>Start Date: </b>
              </label>
              <div>
                <SBADropDown
                  className="w-50"
                  textField={"label"}
                  valueField={"value"}
                  data={customStartdate}
                  value={selectedcustomStartdate}
                  popupSettings={{ className: "modalDD" }}
                  onChange={CustomStartDateChange}
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="header-container m-1">
                <b>End Date: </b>
              </label>
              <div>
                <SBADropDown
                  className="w-50"
                  textField={"label"}
                  valueField={"value"}
                  data={customEnddate}
                  value={selectedcustomEnddate}
                  popupSettings={{ className: "modalDD" }}
                  onChange={CustomEndDateChange}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="header-container m-1">
                <b>Task Type:</b>
              </label>
              <div>
                <SBAMultiSelectCheck
                  className="w-50"
                  data={taskType}
                  value={selectedcustomtaskViewType}
                  dataItemKey="TaskTypeId"
                  textField="TaskType"
                  popupSettings={{ className: "modalDD" }}
                  onChange={customtasktypenameonchange}
                  tags={
                    selectedcustomtaskViewType?.length > 0
                      ? [
                        {
                          text: `${selectedcustomtaskViewType?.length} items selected`,
                          data: [...selectedcustomtaskViewType],
                        },
                      ]
                      : []
                  }
                />
              </div>
            </div>
            <div className="p-2">
              <input
                className="p-4"
                type="checkbox"
                id="completedDate"
                checked={selectedcustomhidecompleted}
                onChange={changecustomhidecompleted}
              />
              <label className="label ms-2">Enable Hide Completed</label>
            </div>

            <div></div>
            <div className='gridcontent d-flex flex-row mt-3' >
              <div className='gridDiv' >
                <div className=''>Available View Columns</div>
                <div className="griddata ag-theme-alpine" style={{ height: '20rem', width: 300 }}>
                  <AgGridReact
                    columnDefs={AvailablecolumnDefs}
                    rowData={availcolumns}
                    rowSelection={'single'}
                    ref={availablecolumnRef}
                    defaultColDef={defaultColDef}
                  >
                  </AgGridReact>
                </div>
              </div>
              <div className='d-flex flex-column justify-content-center px-3'>
                <button className='p-sm-btn my-1' onClick={addViewColumns}>
                  <i class="fa-solid fa-arrow-right"></i>
                </button>
                <button className='p-sm-btn my-1' onClick={removeViewColumns}>
                  <i class="fa-solid fa-arrow-left"></i>
                </button>

              </div>
              <div className='gridDiv'>
                <div className=''>
                  Selected View Columns
                </div>
                {availableviewColumnsloading ? (
                  <LoadingScreen />
                ) : (
                  <>
                    <div className='griddata ag-theme-alpine' style={{ height: '20rem', width: 300 }}>
                      <AgGridReact
                        columnDefs={selectedcolumnDefs}
                        rowData={selectedviewColumns}
                        defaultColDef={defaultColDef}
                        ref={selectedViewcolumnApi}
                        rowSelection={'single'}
                        onRowDragEnd={updateSortOrder}
                        rowDragManaged={true}
                        animateRows={true}
                      >
                      </AgGridReact>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="mt-4">
              <button className="s-sm-btn mx-1" onClick={() => {
                setshowView(false);
              }}>
                Cancel
              </button>
              <button className="p-sm-btn mx-1" onClick={() => { InsertTaskViewsColumn("Edit") }}>
                Save
              </button>
              <button className="p-sm-btn mx-1" onClick={InsertNewview}>
                Save As
              </button>
            </div>
          </div>
        </div>
      </SBADrawer>

      {/* Rename View Modal ----- */}
      <Modal className="modal" show={showRenameView}>
        <Modal.Header
          closeButton
          onClick={() => {
            setshowRenameView(false)
          }}
        >
          <Modal.Title>
            {titleName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-4">
              <Form.Label>View Name: </Form.Label>
              <Form.Control
                className="form-control w-75"
                type="text"
                value={viewName}
                onChange={txtChangeNewName}
                autoFocus
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setshowRenameView(false);
            }}
          >
            Cancel
          </button>
          {titleName === "Rename View" ?
            <button
              className="p-sm-btn mx-1"
              onClick={UpdateTaskViewsColumn}>
              Rename
            </button>
            :
            <button
              className="p-sm-btn mx-1"
              onClick={() => { InsertTaskViewsColumn("New") }}>
              Save
            </button>

          }
        </Modal.Footer>
      </Modal>

      {/* View Delete Modal ----- */}
      <Modal show={showdeleteviewModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowdeleteviewModal(false);
          }}
        >
          <Modal.Title>
            Delete View
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want delete selected view?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setShowdeleteviewModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={deleteTaskview}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <AttachmentModal  showModal={showAttachment} closeModal={()=>{setShowAttachment(false);setRender(value=>!value)}} task={task}/>
      <ToastContainer />
    </>
  );
};
export const TaskGrid = ({ taskGridRef, colDef, appliedFilter, tasks ,taskLoading}) => {
  return <div
    className="ag-theme-alpine"
    style={{ width: "100%", height: "70vh" }}
  >
    <SBGrid
      ref={taskGridRef}
      column={colDef}
      row={tasks}
      pageSize={15}
      rowSelection="single"
      filters={appliedFilter}
      componentID={1015}
      dataLoading={taskLoading}
      gridStyle={{ width: "100%", height: "700px" }}
    ></SBGrid>
  </div>
}
const getDateFormatted = (params) => {
  const isoDate = params.value;
  return isoDate ? moment(isoDate).format("MM-DD-YYYY") : "";
};
const getFormattedDate=(value)=>{
  return value ? moment(value).format("MM-DD-YYYY") : "";
};
const removeHtmlTagsFormatter= (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  return value.replace(/<[^>]*>?/gm, '');
};
